module.exports = __webpack_public_path__ + "img/liucheng4.9394277a.jpg";